export default "__VITE_ASSET__1a8979f0__"